export default __webpack_public_path__ + "static/media/redirect_black.559c3de7.svg";